import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PwLanguageSelectModule } from '@pw-language-select/pw-language-select.module';
import { PublicHeaderComponent } from '@pw-layout/components/public-header/public-header.component';
import { FooterContactBlockComponent } from './components/footer-contact-block/footer-contact-block.component';
import { HeaderMenuOptionComponent } from './components/header-menu-option/header-menu-option.component';
import { HeaderMenuComponent } from './components/header-menu/header-menu.component';
import { PwFooterSmallLinksComponent } from './components/pw-footer-small-link/pw-footer-small-link.component';
import { PwFooterComponent } from './components/pw-footer/pw-footer.component';
import { PwLandingHeaderComponent } from './components/pw-landing-header/pw-landing-header.component';
import { PwRouterLinksContainerComponent } from './components/pw-router-links-container/pw-router-links-container.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@NgModule({
  declarations: [
    PwFooterComponent,
    PwRouterLinksContainerComponent,
    FooterContactBlockComponent,
    PwFooterSmallLinksComponent,
    PwLandingHeaderComponent,
    HeaderMenuComponent,
    HeaderMenuOptionComponent,
    SidebarComponent,
    PublicHeaderComponent,
  ],
  exports: [
    PwFooterComponent,
    PwRouterLinksContainerComponent,
    FooterContactBlockComponent,
    PwFooterSmallLinksComponent,
    PwLandingHeaderComponent,
    HeaderMenuComponent,
    HeaderMenuOptionComponent,
    SidebarComponent,
    PublicHeaderComponent,
  ],
  imports: [CommonModule, RouterModule, TranslateModule, PwLanguageSelectModule],
})
export class PwLayoutModule {}
